// import React, { useEffect, useState } from "react";
// import {
//   Grid,
//   Card,
//   CardContent,
//   Typography,
//   Box,
//   Divider,
//   Chip,
//   ListItem,
//   ListItemText,
//   List,
// } from "@mui/material";
// import { useParams } from "react-router-dom";
// import axios from "axios";
// import CardSkeleton from "utils/CardSkeleton";
// import { getTimeStatus } from "utils/getTimeStatus";
// import { getTimeStatusWithStatus } from "utils/getTimeStatus";

// const statusColorMap = {
//   delivered: "success",
//   accepted: "info",
//   pending: "warning",
//   paid: "success",
//   cancel: "error",
//   "order cancelled": "error",
//   "Order Cancelled": "info",
//   refund_initiated: "info",
//   refund_cancelled: "default",
//   refund_processing: "info",
//   refund_completed: "success",
//   failed: "error",
//   completed: "success",
//   picked: "info",
//   online: "primary",
//   assigned: "secondary",
//   Completed: "success",
//   Assigned: "secondary",
// };
// // MUI color variants (optional use for themes)
// const muiColors = [
//   "primary",
//   "secondary",
//   "error",
//   "success",
//   "warning",
//   "info",
// ];

// // Actual CSS color values
// const textColors = [
//   "#e91e63",
//   "#3f51b5",
//   "#009688",
//   "#ff9800",
//   "#4caf50",
//   "#f44336",
//   "#9c27b0",
// ];

// export default function OpenOrdersIndividual() {
//   const { id } = useParams();
//   const [order, setOrder] = useState(null);
//   const [muiColor, setMuiColor] = useState("primary");
//   const [textColor, setTextColor] = useState("#000");
//   const [loadingError, setLoadingError] = useState(false);
//   const isAnyAccepted = order?.pharmacies?.some((p) => p.status === "accepted");
//   const fetchOrder = async () => {
//     try {
//       const res = await axios.get(
//         `https://api.medstown.com/customer/order/${id}/team`
//       );
//       if (res.data.list) {
//         console.log(res.data.list);
//         setOrder(res.data.list);
//         // const isAnyAccepted = order?.pharmacies?.some(p => p.status === "accepted");
//         setLoadingError(false);
//       } else {
//         setLoadingError(true);
//       }
//     } catch (error) {
//       console.error("Error fetching order:", error);
//       setLoadingError(true);
//     }
//   };

//   useEffect(() => {
//     fetchOrder();
//     setMuiColor(muiColors[Math.floor(Math.random() * muiColors.length)]);
//     setTextColor(textColors[Math.floor(Math.random() * textColors.length)]);
//   }, [id]);

//   if (!order) {
//     return (
//       <Box p={3}>
//         <Typography
//           variant="h4"
//           gutterBottom
//           color={muiColor}
//           sx={{ color: textColor }} // override actual text color here
//         >
//           Open Order Details
//         </Typography>
//         <CardSkeleton count={4} />
//         {loadingError ? (
//           <Typography color="error" mt={2}>
//             Order not found or failed to load.
//           </Typography>
//         ) : (
//           <CardSkeleton count={4} />
//         )}
//       </Box>
//     );
//   }

//   return (
//     <Box p={3}>
//       <Typography variant="h4" gutterBottom>
//         Open Order Details
//       </Typography>

//       <Grid container spacing={3}>
//         {/* Customer Info */}
//         <Grid item xs={12} md={6} sx={{ display: "flex" }}>
//           <Card
//             elevation={1}
//             sx={{ flexGrow: 1, display: "flex", flexDirection: "column" }}
//           >
//             <CardContent sx={{ flexGrow: 1 }}>
//               <Typography variant="h6" gutterBottom>
//                 Customer Info
//               </Typography>
//               <Divider sx={{ mb: 2 }} />
//               <Typography>
//                 <strong>Name:</strong>{" "}
//                 {order?.order?.customerName ? order?.order?.customerName : "NA"}
//               </Typography>
//               <Typography>
//                 <strong>Phone:</strong>{" "}
//                 {order?.order?.customerPhone
//                   ? order?.order?.customerPhone
//                   : "NA"}
//               </Typography>
//               {/* <Typography><strong>Location:</strong> Lat: {order.userLat}, Lng: {order.userLng}</Typography> */}
//               <Typography>
//                 <strong>Status:</strong>{" "}
//                 {order?.order?.status ? order?.order?.status : "NA"}
//               </Typography>
//               <Typography>
//                 <strong>Pharmacy Pincode:</strong>{" "}
//                 {order?.userdetails?.pincode ? order.userdetails.pincode : "NA"}
//               </Typography>
//               <Typography>
//                 <strong>Distance from User:</strong>{" "}
//                 {order?.pharmacies?.[0]?.pharmacydistance
//                   ? `${order?.pharmacies[0]?.pharmacydistance} km`
//                   : "NA"}
//               </Typography>
//               <Typography>
//                 <strong>Distance from User:</strong>
//                 <Typography variant="h6">
//                   <strong>Duration</strong> :{" "}
//                   {order.status === "Delivered" ||
//                   order.status === "Order Cancelled" ? (
//                     <span>
//                       {getTimeStatusWithStatus(
//                         order?.order?.createdAt,
//                         order?.order?.updatedAt,
//                         order?.order?.status
//                       )}
//                     </span>
//                   ) : (
//                     <span
//                       style={{
//                         color: getTimeStatus(order?.order?.createdAt).includes(
//                           "Time Exceeded"
//                         )
//                           ? "red"
//                           : "inherit",
//                       }}
//                     >
//                       {getTimeStatus(order?.order?.createdAt)}
//                     </span>
//                   )}
//                 </Typography>
//               </Typography>
//             </CardContent>
//           </Card>
//         </Grid>

//         {/* Order Info */}
//         <Grid item xs={12} md={6} sx={{ display: "flex" }}>
//           <Card
//             elevation={1}
//             sx={{ flexGrow: 1, display: "flex", flexDirection: "column" }}
//           >
//             <CardContent sx={{ flexGrow: 1 }}>
//               <Typography variant="h6" gutterBottom>
//                 Order Information
//               </Typography>
//               <Divider sx={{ mb: 2 }} />
//               <Typography>
//                 <strong>Order ID:</strong> {order?.order?.orderId}
//               </Typography>
//               <Typography>
//                 <strong>Order Type:</strong> {order?.order?.orderType}
//               </Typography>
//               <Typography>
//                 <strong>Status:</strong>
//                 <Chip
//                   label={order?.order?.status
//                     .replace(/_/g, " ")
//                     .replace(/\b\w/g, (c) => c.toUpperCase())}
//                   color={statusColorMap[order.status] || "default"}
//                   size="small"
//                   sx={{ ml: 1 }}
//                 />
//               </Typography>
//               <Typography>
//                 <strong>Placed On:</strong>{" "}
//                 {new Date(order?.order?.createdAt).toLocaleString()}
//               </Typography>
//               {order?.order?.customer_address && (
//                 <>
//                   <Typography>
//                     <strong>Delivery Location:</strong>{" "}
//                     {order?.order?.customer_address?.details?.house},{" "}
//                     {order?.order?.customer_address?.details?.apartment},{" "}
//                     {order?.order?.customer_address?.street},{" "}
//                     {order?.order?.customer_address?.district},{" "}
//                     {order?.order?.customer_address?.city},{" "}
//                     {order?.order?.customer_address?.region} -{" "}
//                     {order?.order?.customer_address?.postalCode}
//                   </Typography>
//                   <Typography>
//                     <strong>Alternative Phone Number:</strong> {"  "}
//                     {order?.order?.customer_address?.details?.receiverPhone
//                       ? order?.order?.customer_address?.details?.receiverPhone
//                       : "NA"}
                    
//                   </Typography>
//                 </>
//               )}
//             </CardContent>
//           </Card>
//         </Grid>

//         {/* Ordered Medicine Info */}
//         <Grid item xs={12} md={6} sx={{ display: "flex" }}>
//           <Card
//             elevation={1}
//             sx={{ flexGrow: 1, display: "flex", flexDirection: "column" }}
//           >
//             <CardContent sx={{ flexGrow: 1 }}>
//               <Typography variant="h6" gutterBottom>
//                 Ordered Medicines
//               </Typography>
//               <Divider sx={{ mb: 2 }} />
//               <List>
//                 {order?.order?.orderDetails?.map((med) => (
//                   <ListItem
//                     key={med.medicineId}
//                     alignItems="flex-start"
//                     disableGutters
//                   >
//                     <ListItemText
//                       primary={`Name:  ${med.medicineName}  (x${med.medicineQuantity})`}
//                       secondary={
//                         <>
//                           <Typography variant="body2" color="text.primary">
//                             Pack Size Label:{" "}
//                             {med.pack_size_label ? med.pack_size_label : "NA"}
//                           </Typography>
//                           <Typography variant="body2" color="text.primary">
//                             Price: ₹ {med.medicinePrice}
//                           </Typography>
//                           <Typography variant="body2" color="text.secondary">
//                             Type: {med.type}
//                           </Typography>
//                           {/* <Typography variant="body2" color="text.secondary">
//                             Customer Saved: ₹ {med.userSavedAmount}
//                           </Typography>
//                           <Typography variant="body2" color="text.secondary">
//                             Medstown Saved: ₹ {med.medstownSavedAmount}
//                           </Typography> */}
//                         </>
//                       }
//                     />
//                   </ListItem>
//                 ))}
//               </List>
//             </CardContent>
//           </Card>
//         </Grid>

//         {/* Payment Info */}
//         <Grid item xs={12} md={6} sx={{ display: "flex" }}>
//           <Card
//             elevation={1}
//             sx={{ flexGrow: 1, display: "flex", flexDirection: "column" }}
//           >
//             <CardContent sx={{ flexGrow: 1 }}>
//               <Typography variant="h6" gutterBottom>
//                 Payment Info
//               </Typography>
//               <Divider sx={{ mb: 2 }} />
//               <Typography>
//                 <strong>Payment Methods:</strong>{" "}
//                 {order?.order?.payment?.method}
//               </Typography>
//               <Typography>
//                 <strong>Total Amount:</strong> ₹{" "}
//                 {order?.order?.payment.total_amount}
//               </Typography>
//               <Typography>
//                 <strong>Final Amount:</strong> ₹{" "}
//                 {order?.order.payment?.final_amount}
//               </Typography>
//               <Typography>
//                 <strong>Free Cash:</strong> ₹{" "}
//                 {order?.order?.payment.wallet.wallet_used_amount}
//               </Typography>
//               <Typography>
//                 <strong>Delivery Charges:</strong> ₹{" "}
//                 {order?.order?.payment?.delivery_charges}
//               </Typography>
//               {/* <Typography><strong>Payment ID:</strong> {order?.payment?.payment_id || "N/A"}</Typography> */}
//             </CardContent>
//           </Card>
//         </Grid>

//         {/* Delivery Boy Info */}
//         <Grid item xs={12} md={6} sx={{ display: "flex" }}>
//           <Card
//             elevation={1}
//             sx={{ flexGrow: 1, display: "flex", flexDirection: "column" }}
//           >
//             <CardContent sx={{ flexGrow: 1 }}>
//               <Typography variant="h6" gutterBottom>
//                 Delivery Partner Info
//               </Typography>
//               <Divider sx={{ mb: 2 }} />

//               {order?.pharmacies &&
//               order?.pharmacies.some(
//                 (pharmacy) => pharmacy.type === null || pharmacy.deliveryBoyName
//               ) ? (
//                 order.pharmacies.map((pharmacy, index) => {
//                   const showDelivery =
//                     pharmacy.type === null || pharmacy.deliveryBoyName;

//                   if (!showDelivery) return null;

//                   return (
//                     <div key={index} style={{ marginBottom: "1rem" }}>
//                       <Typography>
//                         <strong>Id:</strong> {pharmacy?.deliveryBoyId}
//                       </Typography>
//                       <Typography>
//                         <strong>Name:</strong> {pharmacy?.deliveryBoyName}
//                       </Typography>
//                       <Typography>
//                         <strong>Phone:</strong> {pharmacy?.deliveryBoyPhone}
//                       </Typography>
//                       <Typography>
//                         <strong>Status:</strong> {pharmacy?.status}
//                       </Typography>
//                     </div>
//                   );
//                 })
//               ) : (
//                 <Typography>Delivery Partner not assigned yet.</Typography>
//               )}
//             </CardContent>
//           </Card>
//         </Grid>
//         {/* Pharmacies Info */}
//         <Grid item xs={12} md={6} sx={{ display: "flex" }}>
//           <Card
//             elevation={1}
//             sx={{
//               flexGrow: 1,
//               display: "flex",
//               flexDirection: "column",
//               maxHeight: "350px",
//               overflowY: "auto",
//             }}
//           >
//             <CardContent sx={{ flexGrow: 1 }}>
//               <Typography variant="h6" gutterBottom>
//                 Pharmacies
//               </Typography>
//               <Divider sx={{ mb: 2 }} />

//               {order?.pharmacies &&
//               order?.pharmacies.some((pharmacy) => pharmacy.type !== null) ? (
//                 order.pharmacies.map((pharmacy, index) => {
//                   const showDelivery = pharmacy.type !== null;

//                   if (!showDelivery) return null;

//                   return (
//                     <div
//                       key={index}
//                       style={{
//                         marginBottom: "1rem",
//                         padding: 5,
//                         borderRadius: 10,
//                         border:
//                           pharmacy.status === "accepted"
//                             ? "2px solid #3A7D44"
//                             : "none",
//                       }}
//                     >
//                       <Typography>
//                         <strong>Name:</strong> {pharmacy.pharmacyName}
//                       </Typography>
//                       <Typography>
//                         <strong>Phone Number:</strong> {pharmacy.pharmacyPhone}
//                       </Typography>
//                       <Typography>
//                         <strong>Status:</strong> {pharmacy.status}
//                       </Typography>
//                     </div>
//                   );
//                 })
//               ) : (
//                 <Typography>Delivery Partner not assigned yet.</Typography>
//               )}
//             </CardContent>
//           </Card>
//         </Grid>

//         {/* Accepted Pharmacies Info */}
//         <Grid item xs={12} md={6} sx={{ display: "flex" }}>
//           <Card
//             elevation={1}
//             sx={{
//               flexGrow: 1,
//               display: "flex",
//               flexDirection: "column",
//               maxHeight: "350px",
//               overflowY: "auto",
//             }}
//           >
//             <CardContent sx={{ flexGrow: 1 }}>
//               <Typography variant="h6" gutterBottom>
//                 Accepted Pharmacy Info
//               </Typography>
//               <Divider sx={{ mb: 2 }} />
//               {order?.pharmacies &&
//               order.pharmacies.some(
//                 (pharmacy) =>
//                   pharmacy.type !== null && pharmacy.status === "accepted"
//               ) ? (
//                 order.pharmacies.map((pharmacy, index) => {
//                   const showDelivery =
//                     pharmacy.type !== null && pharmacy.status === "accepted";

//                   if (!showDelivery) return null;

//                   return (
//                     <div
//                       key={index}
//                       style={{
//                         marginBottom: "1rem",
//                         padding: "1rem",
//                         border: "1px solid #ccc",
//                         borderRadius: "8px",
//                       }}
//                     >
//                       <Typography>
//                         <strong>Name:</strong> {pharmacy.pharmacyName}
//                       </Typography>
//                       <Typography>
//                         <strong>Phone Number:</strong> {pharmacy.pharmacyPhone}
//                       </Typography>
//                       <Typography>
//                         <strong>Status:</strong> {pharmacy.status}
//                       </Typography>
//                       {/* <Typography>
//                         <strong>Order ID:</strong> {pharmacy.orderId}
//                       </Typography>
//                       <Typography>
//                         <strong>Customer Name:</strong> {pharmacy.customerName}
//                       </Typography>
//                       <Typography>
//                         <strong>Customer Phone:</strong>{" "}
//                         {pharmacy.customerPhone}
//                       </Typography>
//                       <Typography>
//                         <strong>Delivery Type:</strong> {pharmacy.type}
//                       </Typography>
//                       <Typography>
//                         <strong>Created At:</strong>{" "}
//                         {new Date(pharmacy.createdAt).toLocaleString()}
//                       </Typography>
//                       <Typography>
//                         <strong>Total Price:</strong> ₹{pharmacy.totalPrice}
//                       </Typography>
//                       {pharmacy.customer_address?.details && (
//                         <Typography>
//                           <strong>Customer Address:</strong>{" "}
//                           {`${pharmacy.customer_address.details.house}, ${pharmacy.customer_address.details.apartment} (${pharmacy.customer_address.details.label})`}
//                         </Typography>
//                       )} */}
//                     </div>
//                   );
//                 })
//               ) : (
//                 <Typography>Pharmacy not assigned yet.</Typography>
//               )}
//             </CardContent>
//           </Card>
//         </Grid>

//         {/* Prescription Image */}
//         {order.precriptionUrl && (
//           <Grid item xs={12}>
//             <Card elevation={1}>
//               <CardContent>
//                 <Typography variant="h6" gutterBottom>
//                   Prescription Image
//                 </Typography>
//                 <Divider sx={{ mb: 2 }} />
//                 <Box
//                   component="img"
//                   src={order.precriptionUrl}
//                   alt="Prescription"
//                   sx={{
//                     width: "100%",
//                     maxHeight: 400,
//                     objectFit: "contain",
//                     borderRadius: 2,
//                   }}
//                 />
//               </CardContent>
//             </Card>
//           </Grid>
//         )}
//       </Grid>
//     </Box>
//   );
// }











import React, { useEffect, useState } from "react";
import {
  Grid,
  Card,
  CardContent,
  Typography,
  Box,
  Chip,
  Avatar,
  Stack,
  IconButton,
  useTheme,
  alpha,
  LinearProgress,
  Skeleton,
  Alert,
  Button,
  Paper,
  Fade,
  Container,
  TextField,
  CircularProgress,
  Snackbar,
} from "@mui/material";
import {
  MdPerson,
  MdPhone,
  MdLocationOn,
  MdShoppingCart,
  MdPayment,
  MdLocalShipping,
  MdStore,
  MdImage,
  MdCall,
  MdCheckCircle,
  MdCancel,
  MdSchedule,
  MdHourglassEmpty,
  MdArrowBack,
  MdInfo,
  MdLink,
  MdContentCopy,
  MdSave,
} from "react-icons/md";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import dayjs from "dayjs";
import {
  getTimeStatus,
  getTimeStatusWithStatus,
  getDeliveryTimingLabel,
  getScheduledDispatchInfo,
} from "utils/getTimeStatus";
import CancelRefundModal from "./CancelRefundModal";

const OpenOrdersIndividual = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const theme = useTheme();
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [awbForm, setAwbForm] = useState({ awbNumber: "", awbTrackingUrl: "", courierPartner: "" });
  const [savingAwb, setSavingAwb] = useState(false);
  const [awbSnack, setAwbSnack] = useState({ open: false, msg: "", severity: "success" });
  const [cancelOpen, setCancelOpen] = useState(false);

  const getStatusConfig = (status) => {
    const normalizedStatus = status?.toLowerCase();
    const configs = {
      "delivered": {
        color: "#4caf50",
        bgColor: alpha("#4caf50", 0.1),
        icon: <MdCheckCircle size={10} />
      },
      "pending": {
        color: "#ff9800",
        bgColor: alpha("#ff9800", 0.1),
        icon: <MdSchedule size={10} />
      },
      "processing": {
        color: "#2196f3",
        bgColor: alpha("#2196f3", 0.1),
        icon: <MdHourglassEmpty size={10} />
      },
      "accepted": {
        color: "#4caf50",
        bgColor: alpha("#4caf50", 0.1),
        icon: <MdCheckCircle size={10} />
      },
      "order cancelled": {
        color: "#f44336",
        bgColor: alpha("#f44336", 0.1),
        icon: <MdCancel size={10} />
      },
      "cancelled": {
        color: "#f44336",
        bgColor: alpha("#f44336", 0.1),
        icon: <MdCancel size={10} />
      }
    };
    return configs[normalizedStatus] || {
      color: "#757575",
      bgColor: alpha("#757575", 0.1),
      icon: <MdInfo size={10} />
    };
  };

  const fetchOrder = async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await axios.get(
        `https://api.medstown.com/customer/order/${id}/team`
      );
      if (res.data.list) {
        setOrder(res.data.list);
        const o = res.data.list?.order || {};
        setAwbForm({
          awbNumber: o.awbNumber || "",
          awbTrackingUrl: o.awbTrackingUrl || "",
          courierPartner: o.courierPartner || "",
        });
      } else {
        setError("Order not found");
      }
    } catch (error) {
      console.error("Error fetching order:", error);
      setError(error.response?.data?.message || "Failed to fetch order details");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOrder();
  }, [id]);

  const handleCall = (phoneNumber) => {
    window.location.href = `tel:${phoneNumber}`;
  };

  const handleSaveAwb = async () => {
    const orderId = order?.order?.orderId;
    if (!orderId) return;
    if (!awbForm.awbTrackingUrl && !awbForm.awbNumber) {
      setAwbSnack({ open: true, msg: "Provide AWB number or tracking URL.", severity: "warning" });
      return;
    }
    if (awbForm.awbTrackingUrl) {
      try {
        new URL(awbForm.awbTrackingUrl);
      } catch {
        setAwbSnack({ open: true, msg: "Tracking URL is not valid.", severity: "warning" });
        return;
      }
    }
    setSavingAwb(true);
    try {
      await axios.put(`https://api.medstown.com/admin/orders/${orderId}/awb`, awbForm);
      setOrder((prev) =>
        prev ? { ...prev, order: { ...prev.order, ...awbForm } } : prev
      );
      setAwbSnack({ open: true, msg: "Tracking saved.", severity: "success" });
    } catch (err) {
      setAwbSnack({
        open: true,
        msg: err?.response?.data?.message || "Failed to save tracking.",
        severity: "error",
      });
    } finally {
      setSavingAwb(false);
    }
  };

  if (loading) {
    return (
      <Container maxWidth="xl" sx={{ py: 2 }}>
        <Box sx={{ mb: 2 }}>
          <Skeleton variant="rectangular" height={50} sx={{ borderRadius: 2, mb: 1 }} />
          <LinearProgress sx={{ borderRadius: 1, height: 4 }} />
        </Box>
        <Grid container spacing={2}>
          {Array.from(new Array(8)).map((_, index) => (
            <Grid item xs={12} md={6} key={index}>
              <Skeleton variant="rectangular" height={250} sx={{ borderRadius: 2 }} />
            </Grid>
          ))}
        </Grid>
      </Container>
    );
  }

  if (error) {
    return (
      <Container maxWidth="xl" sx={{ py: 2 }}>
        <Alert 
          severity="error" 
          sx={{ borderRadius: 2, mb: 2, p: 2 }}
          action={
            <Button onClick={() => navigate(-1)} variant="outlined" size="small">
              Go Back
            </Button>
          }
        >
          <Typography variant="body2" sx={{ mb: 0.5, fontWeight: 600 }}>Error Loading Order</Typography>
          <Typography variant="body2">{error}</Typography>
        </Alert>
      </Container>
    );
  }

  const statusConfig = getStatusConfig(order?.order?.status);

  return (
    <Container maxWidth="xl" sx={{ py: 2 }}>
      {/* Compact Header */}
      <Paper 
        elevation={0} 
        sx={{ 
          p: 2, 
          mb: 2, 
          borderRadius: 2,
          background: `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
          color: 'white'
        }}
      >
        <Stack direction="row" alignItems="center" spacing={2}>
          <IconButton 
            onClick={() => navigate(-1)} 
            size="small"
            sx={{ 
              color: 'white',
              backgroundColor: alpha(theme.palette.common.white, 0.15),
              '&:hover': { backgroundColor: alpha(theme.palette.common.white, 0.25) }
            }}
          >
            <MdArrowBack size={18} />
          </IconButton>
          
          <Box sx={{ flexGrow: 1 }}>
            <Typography variant="h6" fontWeight={700} sx={{ mb: 0.5 }}>
              Order Details
            </Typography>
            <Stack direction="row" alignItems="center" spacing={2} flexWrap="wrap">
              <Typography variant="body2" sx={{ 
                fontFamily: 'monospace',
                backgroundColor: alpha(theme.palette.common.white, 0.15),
                px: 1,
                py: 0.2,
                borderRadius: 1,
                fontSize: '0.75rem'
              }}>
                #{order?.order?.orderId}
              </Typography>
              <Chip 
                label={order?.order?.status}
                icon={statusConfig.icon}
                size="small"
                sx={{ 
                  backgroundColor: 'white',
                  color: statusConfig.color,
                  fontWeight: 600,
                  fontSize: '0.7rem',
                  height: 24
                }}
              />
            </Stack>
          </Box>
          
          <Box textAlign="right">
            <Typography variant="caption" sx={{ opacity: 0.8 }}>
              {dayjs(order?.order?.createdAt).format("MMM DD, YYYY")}
            </Typography>
            <Typography variant="caption" sx={{ opacity: 0.8, display: 'block' }}>
              {dayjs(order?.order?.createdAt).format("hh:mm A")}
            </Typography>
          </Box>

          {!["Delivered", "Order Cancelled"].includes(order?.order?.status) && (
            <Button
              variant="contained"
              size="small"
              onClick={() => setCancelOpen(true)}
              startIcon={<MdCancel size={14} />}
              sx={{
                backgroundColor: "white",
                color: theme.palette.error.main,
                fontWeight: 700,
                fontSize: "0.7rem",
                whiteSpace: "nowrap",
                "&:hover": {
                  backgroundColor: alpha(theme.palette.common.white, 0.9),
                },
              }}
            >
              Cancel & Refund
            </Button>
          )}
        </Stack>
      </Paper>

      <Grid container spacing={2}>
        {/* Customer Information */}
        <Grid item xs={12} md={6}>
          <Card elevation={0} sx={{ 
            borderRadius: 2, 
            border: `1px solid ${alpha(theme.palette.divider, 0.08)}`,
            height: '100%'
          }}>
            <CardContent sx={{ p: 2 }}>
              <Stack direction="row" alignItems="center" spacing={1.5} sx={{ mb: 2 }}>
                <Avatar sx={{ 
                  backgroundColor: alpha(theme.palette.primary.main, 0.1),
                  color: theme.palette.primary.main,
                  width: 32,
                  height: 32
                }}>
                  <MdPerson size={18} />
                </Avatar>
                <Typography variant="body1" fontWeight={600} color="primary.main">
                  Customer Information
                </Typography>
              </Stack>

              <Stack spacing={1.5}>
                <Box>
                  <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 500 }}>
                    Customer Name
                  </Typography>
                  <Typography variant="body2" fontWeight={500}>
                    {order?.order?.customerName || "N/A"}
                  </Typography>
                </Box>

                <Box>
                  <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 500 }}>
                    Phone Number
                  </Typography>
                  <Stack direction="row" alignItems="center" spacing={1}>
                    <Typography variant="body2" sx={{ fontFamily: 'monospace', fontSize: '0.8rem' }}>
                      {order?.order?.customerPhone || "N/A"}
                    </Typography>
                    {order?.order?.customerPhone && (
                      <IconButton
                        size="small"
                        onClick={() => handleCall(order.order.customerPhone)}
                        sx={{
                          color: theme.palette.success.main,
                          backgroundColor: alpha(theme.palette.success.main, 0.1),
                          width: 24,
                          height: 24
                        }}
                      >
                        <MdCall size={12} />
                      </IconButton>
                    )}
                  </Stack>
                </Box>

                <Box>
                  <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 500 }}>
                    Pincode
                  </Typography>
                  <Box>
                    <Chip 
                      label={order?.userdetails?.pincode || "N/A"}
                      size="small"
                      sx={{ 
                        backgroundColor: alpha(theme.palette.info.main, 0.1),
                        color: theme.palette.info.main,
                        fontSize: '0.7rem',
                        height: 20
                      }}
                    />
                  </Box>
                </Box>

                <Box>
                  <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 500 }}>
                    Distance from Pharmacy
                  </Typography>
                  <Typography variant="body2" fontWeight={500}>
                    {order?.pharmacies?.[0]?.pharmacydistance 
                      ? `${order.pharmacies[0].pharmacydistance} km` 
                      : "N/A"}
                  </Typography>
                </Box>

                <Box>
                  <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 500 }}>
                    Order Duration
                  </Typography>
                  {(() => {
                    // Per-delivery-type timing label, replacing the blanket
                    // 30-min countdown. The "Time Exceeded" colour treatment
                    // is only meaningful for express ASAP — Standard /
                    // Scheduled don't have a 30-min SLA.
                    const o = order?.order;
                    const finalLabel =
                      o?.status === "Delivered" ||
                      o?.status === "Order Cancelled"
                        ? getTimeStatusWithStatus(
                            o?.createdAt,
                            o?.updatedAt,
                            o?.status
                          )
                        : getDeliveryTimingLabel(o) ||
                          getTimeStatus(o?.createdAt);
                    const isExceeded = String(finalLabel).includes(
                      "Time Exceeded"
                    );
                    return (
                      <Paper
                        sx={{
                          p: 1,
                          backgroundColor: isExceeded
                            ? alpha(theme.palette.error.main, 0.05)
                            : alpha(theme.palette.success.main, 0.05),
                          border: `1px solid ${
                            isExceeded
                              ? alpha(theme.palette.error.main, 0.2)
                              : alpha(theme.palette.success.main, 0.2)
                          }`,
                          borderRadius: 1,
                        }}
                      >
                        <Typography
                          variant="caption"
                          fontWeight={500}
                          sx={{
                            color: isExceeded
                              ? theme.palette.error.main
                              : theme.palette.success.main,
                          }}
                        >
                          {finalLabel}
                        </Typography>
                      </Paper>
                    );
                  })()}
                </Box>

                {/* Scheduled-dispatch internal info — only renders when the
                    order is a scheduled-Express. Tells ops exactly when the
                    Agenda job is set to fire and whether it has already. */}
                {(() => {
                  const info = getScheduledDispatchInfo(order?.order);
                  if (!info) return null;
                  const minutesUntilFire = Math.round(
                    info.timeUntilFireMs / 60000
                  );
                  return (
                    <Box>
                      <Typography
                        variant="caption"
                        color="text.secondary"
                        sx={{ fontWeight: 500 }}
                      >
                        Scheduled dispatch
                      </Typography>
                      <Paper
                        sx={{
                          p: 1.2,
                          mt: 0.4,
                          backgroundColor: alpha(
                            theme.palette.warning.main,
                            0.06
                          ),
                          border: `1px solid ${alpha(
                            theme.palette.warning.main,
                            0.25
                          )}`,
                          borderRadius: 1,
                        }}
                      >
                        <Typography
                          variant="caption"
                          fontWeight={700}
                          sx={{ color: theme.palette.warning.dark, display: "block" }}
                        >
                          Slot · {info.slotPretty}
                        </Typography>
                        <Typography
                          variant="caption"
                          sx={{ color: "text.secondary", display: "block" }}
                        >
                          Pharmacy notified at: {info.fireAtPretty}
                          {minutesUntilFire > 0 && !info.fired && !info.cancelled
                            ? ` (in ${minutesUntilFire} min)`
                            : ""}
                        </Typography>
                        <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, mt: 0.4 }}>
                          {info.fired ? (
                            <>
                              <MdCheckCircle size={14} color="#059669" />
                              <Typography variant="caption" sx={{ color: "#059669", fontWeight: 700 }}>
                                Fired
                              </Typography>
                            </>
                          ) : info.cancelled ? (
                            <>
                              <MdCancel size={14} color="#B91C1C" />
                              <Typography variant="caption" sx={{ color: "#B91C1C", fontWeight: 700 }}>
                                Cancelled
                              </Typography>
                            </>
                          ) : (
                            <>
                              <MdHourglassEmpty size={14} color="#B45309" />
                              <Typography variant="caption" sx={{ color: "#B45309", fontWeight: 700 }}>
                                {minutesUntilFire > 0 ? "Queued" : "Firing soon"}
                              </Typography>
                            </>
                          )}
                        </Box>
                      </Paper>
                    </Box>
                  );
                })()}
              </Stack>
            </CardContent>
          </Card>
        </Grid>

        {/* Order Information */}
        <Grid item xs={12} md={6}>
          <Card elevation={0} sx={{ 
            borderRadius: 2, 
            border: `1px solid ${alpha(theme.palette.divider, 0.08)}`,
            height: '100%'
          }}>
            <CardContent sx={{ p: 2 }}>
              <Stack direction="row" alignItems="center" spacing={1.5} sx={{ mb: 2 }}>
                <Avatar sx={{ 
                  backgroundColor: alpha(theme.palette.secondary.main, 0.1),
                  color: theme.palette.secondary.main,
                  width: 32,
                  height: 32
                }}>
                  <MdShoppingCart size={18} />
                </Avatar>
                <Typography variant="body1" fontWeight={600} color="secondary.main">
                  Order Information
                </Typography>
              </Stack>

              <Stack spacing={1.5}>
                <Box>
                  <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 500 }}>
                    Order Type
                  </Typography>
                  <Box>
                    <Chip 
                      label={order?.order?.orderType || "N/A"}
                      variant="outlined"
                      size="small"
                      sx={{ 
                        fontSize: '0.7rem',
                        height: 20
                      }}
                    />
                  </Box>
                </Box>

                <Box>
                  <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 500 }}>
                    Current Status
                  </Typography>
                  <Box>
                    <Chip 
                      label={order?.order?.status || "N/A"}
                      icon={statusConfig.icon}
                      size="small"
                      sx={{ 
                        backgroundColor: statusConfig.bgColor,
                        color: statusConfig.color,
                        border: `1px solid ${alpha(statusConfig.color, 0.3)}`,
                        fontWeight: 600,
                        fontSize: '0.7rem',
                        height: 24
                      }}
                    />
                  </Box>
                </Box>

                {order?.order?.customer_address && (
                  <Box>
                    <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 500, mb: 0.5 }}>
                      Delivery Address
                    </Typography>
                    <Paper sx={{ 
                      p: 1.5, 
                      backgroundColor: alpha(theme.palette.info.main, 0.05),
                      border: `1px solid ${alpha(theme.palette.info.main, 0.1)}`,
                      borderRadius: 1
                    }}>
                      <Stack direction="row" spacing={1} alignItems="flex-start">
                        <MdLocationOn size={14} color={theme.palette.info.main} />
                        <Typography variant="caption" sx={{ lineHeight: 1.4 }}>
                          {[
                            order.order.customer_address.details?.house,
                            order.order.customer_address.details?.apartment,
                            order.order.customer_address.street,
                            order.order.customer_address.district,
                            order.order.customer_address.city,
                            order.order.customer_address.region,
                            order.order.customer_address.postalCode
                          ].filter(Boolean).join(", ")}
                        </Typography>
                      </Stack>
                    </Paper>
                  </Box>
                )}

                {order?.order?.customer_address?.details?.receiverPhone && (
                  <Box>
                    <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 500 }}>
                      Alternative Phone
                    </Typography>
                    <Stack direction="row" alignItems="center" spacing={1}>
                      <Typography variant="body2" sx={{ fontFamily: 'monospace', fontSize: '0.8rem' }}>
                        {order.order.customer_address.details.receiverPhone}
                      </Typography>
                      <IconButton
                        size="small"
                        onClick={() => handleCall(order.order.customer_address.details.receiverPhone)}
                        sx={{
                          color: theme.palette.success.main,
                          backgroundColor: alpha(theme.palette.success.main, 0.1),
                          width: 24,
                          height: 24
                        }}
                      >
                        <MdCall size={12} />
                      </IconButton>
                    </Stack>
                  </Box>
                )}
              </Stack>
            </CardContent>
          </Card>
        </Grid>

        {/* Ordered Medicines */}
        <Grid item xs={12} md={6}>
          <Card elevation={0} sx={{ 
            borderRadius: 2, 
            border: `1px solid ${alpha(theme.palette.divider, 0.08)}`,
            height: '100%'
          }}>
            <CardContent sx={{ p: 2 }}>
              <Stack direction="row" alignItems="center" spacing={1.5} sx={{ mb: 2 }}>
                <Avatar sx={{ 
                  backgroundColor: alpha(theme.palette.success.main, 0.1),
                  color: theme.palette.success.main,
                  width: 32,
                  height: 32
                }}>
                  <MdShoppingCart size={18} />
                </Avatar>
                <Typography variant="body1" fontWeight={600} color="success.main">
                  Ordered Medicines
                </Typography>
              </Stack>

              <Box sx={{ maxHeight: 300, overflowY: 'auto' }}>
                <Stack spacing={1.5}>
                  {order?.order?.orderDetails?.map((med, index) => (
                    <Paper 
                      key={med.medicineId || index}
                      sx={{ 
                        p: 1.5, 
                        backgroundColor: alpha(theme.palette.background.paper, 0.8),
                        border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
                        borderRadius: 1
                      }}
                    >
                      <Typography variant="body2" fontWeight={600} sx={{ mb: 1, color: 'primary.main' }}>
                        {med.medicineName} × {med.medicineQuantity}
                      </Typography>
                      <Stack spacing={0.5}>
                        <Typography variant="caption" color="text.secondary">
                          Pack Size: {med.pack_size_label || "N/A"}
                        </Typography>
                        <Stack direction="row" alignItems="center" spacing={1}>
                          <Typography variant="caption" color="text.secondary">Type:</Typography>
                          <Chip label={med.type} size="small" variant="outlined" sx={{ fontSize: '0.6rem', height: 16 }} />
                        </Stack>
                        <Typography variant="body2" color="success.main" fontWeight={600}>
                          ₹{med.medicinePrice}
                        </Typography>
                      </Stack>
                    </Paper>
                  ))}
                </Stack>
              </Box>
            </CardContent>
          </Card>
        </Grid>

        {/* Payment Information */}
        <Grid item xs={12} md={6}>
          <Card elevation={0} sx={{ 
            borderRadius: 2, 
            border: `1px solid ${alpha(theme.palette.divider, 0.08)}`,
            height: '100%'
          }}>
            <CardContent sx={{ p: 2 }}>
              <Stack direction="row" alignItems="center" spacing={1.5} sx={{ mb: 2 }}>
                <Avatar sx={{ 
                  backgroundColor: alpha(theme.palette.warning.main, 0.1),
                  color: theme.palette.warning.main,
                  width: 32,
                  height: 32
                }}>
                  <MdPayment size={18} />
                </Avatar>
                <Typography variant="body1" fontWeight={600} color="warning.main">
                  Payment Details
                </Typography>
              </Stack>

              <Stack spacing={1.5}>
                <Box>
                  <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 500 }}>
                    Payment Method
                  </Typography>
                  <Stack direction="row" alignItems="center" spacing={0.75} sx={{ mt: 0.25 }}>
                    <Chip
                      label={order?.order?.payment?.method || "N/A"}
                      size="small"
                      sx={{
                        backgroundColor: alpha(theme.palette.info.main, 0.1),
                        color: theme.palette.info.main,
                        fontSize: '0.7rem',
                        height: 20
                      }}
                    />
                    {order?.order?.payment?.status && (() => {
                      const ps = order.order.payment.status;
                      const tone = ps === "paid"
                        ? theme.palette.success.main
                        : ps === "refund_completed"
                        ? theme.palette.success.main
                        : ps === "refund_processing" || ps === "refund_initiated"
                        ? theme.palette.warning.main
                        : ps === "refund_cancelled" || ps === "failed" || ps === "cancel"
                        ? theme.palette.error.main
                        : theme.palette.text.secondary;
                      return (
                        <Chip
                          label={ps.replace(/_/g, " ")}
                          size="small"
                          sx={{
                            backgroundColor: alpha(tone, 0.1),
                            color: tone,
                            fontSize: '0.65rem',
                            height: 20,
                            fontWeight: 700,
                            textTransform: 'uppercase',
                          }}
                        />
                      );
                    })()}
                  </Stack>
                </Box>

                <Box>
                  <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 500 }}>
                    Total Amount
                  </Typography>
                  <Typography variant="h6" fontWeight={700} color="success.main">
                    ₹{order?.order?.payment?.total_amount || 0}
                  </Typography>
                </Box>

                <Box>
                  <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 500 }}>
                    Final Amount
                  </Typography>
                  <Typography variant="body1" fontWeight={600}>
                    ₹{order?.order?.payment?.final_amount || 0}
                  </Typography>
                </Box>

                <Box>
                  <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 500 }}>
                    Wallet Used
                  </Typography>
                  <Typography variant="body2" color="primary.main" fontWeight={500}>
                    ₹{order?.order?.payment?.wallet?.wallet_used_amount || 0}
                  </Typography>
                </Box>

                <Box>
                  <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 500 }}>
                    Delivery Charges
                  </Typography>
                  <Typography variant="body2" fontWeight={500}>
                    ₹{order?.order?.payment?.delivery_charges || 0}
                  </Typography>
                </Box>

                {/* Refund details — visible only once a refund has been
                    initiated. Shows type, amount, Razorpay refund id and
                    status so ops can verify the settlement at a glance. */}
                {order?.order?.payment?.refund?.razorpay_refund_id && (
                  <Box
                    sx={{
                      p: 1.2,
                      mt: 0.5,
                      borderRadius: 1,
                      backgroundColor: alpha(theme.palette.error.main, 0.05),
                      border: `1px solid ${alpha(theme.palette.error.main, 0.2)}`,
                    }}
                  >
                    <Stack
                      direction="row"
                      alignItems="center"
                      justifyContent="space-between"
                      sx={{ mb: 0.5 }}
                    >
                      <Typography
                        variant="caption"
                        fontWeight={700}
                        color="error.main"
                        sx={{ textTransform: 'uppercase' }}
                      >
                        Refund · {order.order.payment.refund.type || "—"}
                      </Typography>
                      <Typography variant="body2" fontWeight={700} color="error.main">
                        ₹{Number(order.order.payment.refund.amount || 0).toFixed(2)}
                      </Typography>
                    </Stack>
                    <Typography
                      variant="caption"
                      sx={{ fontFamily: 'monospace', display: 'block' }}
                      color="text.secondary"
                    >
                      {order.order.payment.refund.razorpay_refund_id}
                    </Typography>
                    {order.order.payment.refund.razorpay_status && (
                      <Typography variant="caption" color="text.secondary">
                        Razorpay: {order.order.payment.refund.razorpay_status}
                        {order.order.payment.refund.speed_processed
                          ? ` · ${order.order.payment.refund.speed_processed}`
                          : ""}
                      </Typography>
                    )}
                    {order.order.payment.refund.reason && (
                      <Typography
                        variant="caption"
                        sx={{ display: 'block', mt: 0.25 }}
                        color="text.secondary"
                      >
                        Reason: {order.order.payment.refund.reason}
                      </Typography>
                    )}
                  </Box>
                )}
              </Stack>
            </CardContent>
          </Card>
        </Grid>

        {/* Delivery Partner Info */}
        <Grid item xs={12} md={6}>
          <Card elevation={0} sx={{ 
            borderRadius: 2, 
            border: `1px solid ${alpha(theme.palette.divider, 0.08)}`,
            height: '100%'
          }}>
            <CardContent sx={{ p: 2 }}>
              <Stack direction="row" alignItems="center" spacing={1.5} sx={{ mb: 2 }}>
                <Avatar sx={{ 
                  backgroundColor: alpha(theme.palette.info.main, 0.1),
                  color: theme.palette.info.main,
                  width: 32,
                  height: 32
                }}>
                  <MdLocalShipping size={18} />
                </Avatar>
                <Typography variant="body1" fontWeight={600} color="info.main">
                  Delivery Partner
                </Typography>
              </Stack>

              {order?.pharmacies?.some(p => p.deliveryBoyName) ? (
                <Stack spacing={1.5}>
                  {order.pharmacies
                    .filter(p => p.deliveryBoyName)
                    .map((pharmacy, index) => (
                      <Paper 
                        key={index}
                        sx={{ 
                          p: 1.5, 
                          backgroundColor: alpha(theme.palette.info.main, 0.05),
                          border: `1px solid ${alpha(theme.palette.info.main, 0.1)}`,
                          borderRadius: 1
                        }}
                      >
                        <Stack spacing={1}>
                          <Typography variant="body2" fontWeight={600}>
                            {pharmacy.deliveryBoyName}
                          </Typography>
                          <Stack direction="row" alignItems="center" justifyContent="space-between">
                            <Typography variant="caption" sx={{ fontFamily: 'monospace' }}>
                              {pharmacy.deliveryBoyPhone}
                            </Typography>
                            <IconButton
                              size="small"
                              onClick={() => handleCall(pharmacy.deliveryBoyPhone)}
                              sx={{
                                color: theme.palette.success.main,
                                backgroundColor: alpha(theme.palette.success.main, 0.1),
                                width: 24,
                                height: 24
                              }}
                            >
                              <MdCall size={12} />
                            </IconButton>
                          </Stack>
                          <Chip 
                            label={pharmacy.status}
                            size="small"
                            sx={{ 
                              backgroundColor: getStatusConfig(pharmacy.status).bgColor,
                              color: getStatusConfig(pharmacy.status).color,
                              alignSelf: 'flex-start',
                              fontSize: '0.7rem',
                              height: 20
                            }}
                          />
                        </Stack>
                      </Paper>
                    ))}
                </Stack>
              ) : (
                <Box textAlign="center" sx={{ py: 3 }}>
                  <Typography variant="body2" color="text.secondary">
                    Delivery partner not assigned yet
                  </Typography>
                </Box>
              )}
            </CardContent>
          </Card>
        </Grid>

        {/* Delivery & Tracking — only for Standard (courier) orders that
            are still in flight. Hidden for Express (runner flow) and for
            Delivered / Order Cancelled (AWB no longer relevant). */}
        {order?.order?.deliveryType === "standard" &&
          !["Delivered", "Order Cancelled"].includes(order?.order?.status) && (
        <Grid item xs={12} md={6}>
          <Card
            elevation={0}
            sx={{
              borderRadius: 2,
              border: `1px solid ${alpha(theme.palette.divider, 0.08)}`,
              height: "100%",
            }}
          >
            <CardContent sx={{ p: 2 }}>
              <Stack direction="row" alignItems="center" spacing={1.5} sx={{ mb: 2 }}>
                <Avatar
                  sx={{
                    backgroundColor: alpha(theme.palette.success.main, 0.1),
                    color: theme.palette.success.main,
                    width: 32,
                    height: 32,
                  }}
                >
                  <MdLink size={18} />
                </Avatar>
                <Typography variant="body1" fontWeight={600} color="success.main">
                  Delivery & Tracking
                </Typography>
                {order?.order?.deliveryType && (
                  <Chip
                    label={order.order.deliveryType.toUpperCase()}
                    size="small"
                    sx={{
                      backgroundColor: alpha(theme.palette.primary.main, 0.1),
                      color: theme.palette.primary.main,
                      fontWeight: 700,
                      fontSize: "0.65rem",
                      height: 20,
                    }}
                  />
                )}
              </Stack>

              {order?.order?.deliveryType === "instant" && order?.order?.scheduledSlot?.label && (
                <Box sx={{ mb: 2, p: 1.2, borderRadius: 1, bgcolor: alpha(theme.palette.warning.main, 0.06) }}>
                  <Typography variant="caption" color="text.secondary" fontWeight={500}>
                    Scheduled Slot
                  </Typography>
                  <Typography variant="body2" fontWeight={600}>
                    {order.order.scheduledSlot.date} · {order.order.scheduledSlot.label}
                  </Typography>
                </Box>
              )}

              <Stack spacing={1.2}>
                <TextField
                  label="Courier Partner"
                  size="small"
                  value={awbForm.courierPartner}
                  onChange={(e) => setAwbForm({ ...awbForm, courierPartner: e.target.value })}
                  placeholder="Delhivery / Bluedart / DTDC ..."
                  fullWidth
                />
                <TextField
                  label="AWB Number"
                  size="small"
                  value={awbForm.awbNumber}
                  onChange={(e) => setAwbForm({ ...awbForm, awbNumber: e.target.value })}
                  fullWidth
                />
                <TextField
                  label="Tracking URL"
                  size="small"
                  value={awbForm.awbTrackingUrl}
                  onChange={(e) => setAwbForm({ ...awbForm, awbTrackingUrl: e.target.value })}
                  placeholder="https://..."
                  fullWidth
                />
                {awbForm.awbTrackingUrl && (
                  <Stack direction="row" spacing={1} alignItems="center">
                    <Button
                      size="small"
                      startIcon={<MdLink />}
                      onClick={() => window.open(awbForm.awbTrackingUrl, "_blank")}
                    >
                      Open Link
                    </Button>
                    <Button
                      size="small"
                      startIcon={<MdContentCopy />}
                      onClick={() => {
                        navigator.clipboard.writeText(awbForm.awbTrackingUrl);
                        setAwbSnack({ open: true, msg: "Copied", severity: "success" });
                      }}
                    >
                      Copy
                    </Button>
                  </Stack>
                )}
                <Button
                  variant="contained"
                  startIcon={savingAwb ? <CircularProgress size={14} sx={{ color: "white" }} /> : <MdSave />}
                  onClick={handleSaveAwb}
                  disabled={savingAwb}
                  sx={{ alignSelf: "flex-start", mt: 1 }}
                >
                  Save Tracking
                </Button>
              </Stack>
            </CardContent>
          </Card>
        </Grid>
        )}

        {/* Pharmacies Info - With Accepted Pharmacy First */}
        <Grid item xs={12} md={6}>
          <Card elevation={0} sx={{ 
            borderRadius: 2, 
            border: `1px solid ${alpha(theme.palette.divider, 0.08)}`,
            height: '100%'
          }}>
            <CardContent sx={{ p: 2 }}>
              <Stack direction="row" alignItems="center" spacing={1.5} sx={{ mb: 2 }}>
                <Avatar sx={{ 
                  backgroundColor: alpha(theme.palette.secondary.main, 0.1),
                  color: theme.palette.secondary.main,
                  width: 32,
                  height: 32
                }}>
                  <MdStore size={18} />
                </Avatar>
                <Typography variant="body1" fontWeight={600} color="secondary.main">
                  Associated Pharmacies
                </Typography>
              </Stack>

              <Box sx={{ maxHeight: 350, overflowY: 'auto' }}>
                <Stack spacing={1.5}>
                  {/* Sort pharmacies to show accepted ones first */}
                  {order?.pharmacies
                    ?.filter(p => p.type !== null)
                    ?.sort((a, b) => {
                      if (a.status === "accepted" && b.status !== "accepted") return -1;
                      if (a.status !== "accepted" && b.status === "accepted") return 1;
                      return 0;
                    })
                    ?.map((pharmacy, index) => {
                      const isAccepted = pharmacy.status === "accepted";
                      const statusConfig = getStatusConfig(pharmacy.status);
                      
                      return (
                        <Paper 
                          key={index}
                          sx={{ 
                            p: 2, 
                            backgroundColor: isAccepted
                              ? `linear-gradient(135deg, ${alpha(theme.palette.success.main, 0.08)}, ${alpha(theme.palette.success.main, 0.04)})`
                              : alpha(theme.palette.background.paper, 0.8),
                            border: isAccepted
                              ? `2px solid ${theme.palette.success.main}`
                              : `1px solid ${alpha(theme.palette.divider, 0.1)}`,
                            borderRadius: 2,
                            position: 'relative'
                          }}
                        >
                          {/* Accepted Badge */}
                          {isAccepted && (
                            <Box
                              sx={{
                                position: 'absolute',
                                top: -6,
                                right: 8,
                                backgroundColor: theme.palette.success.main,
                                color: 'white',
                                px: 1,
                                py: 0.2,
                                borderRadius: 1,
                                fontSize: '0.6rem',
                                fontWeight: 700,
                                textTransform: 'uppercase'
                              }}
                            >
                              ✓ ACCEPTED
                            </Box>
                          )}

                          <Stack spacing={1.5}>
                            {/* Pharmacy Name */}
                            <Stack direction="row" alignItems="center" spacing={1.5}>
                              <Avatar sx={{ 
                                backgroundColor: isAccepted 
                                  ? theme.palette.success.main 
                                  : alpha(theme.palette.secondary.main, 0.1),
                                color: isAccepted 
                                  ? 'white' 
                                  : theme.palette.secondary.main,
                                width: 28,
                                height: 28
                              }}>
                                <MdStore size={14} />
                              </Avatar>
                              <Box sx={{ flexGrow: 1 }}>
                                <Typography 
                                  variant="body2" 
                                  fontWeight={isAccepted ? 700 : 600}
                                  sx={{ 
                                    color: isAccepted ? theme.palette.success.main : 'inherit'
                                  }}
                                >
                                  {pharmacy.pharmacyName}
                                </Typography>
                                {isAccepted && (
                                  <Typography 
                                    variant="caption" 
                                    sx={{ 
                                      color: theme.palette.success.main,
                                      fontWeight: 600,
                                      textTransform: 'uppercase',
                                      fontSize: '0.6rem'
                                    }}
                                  >
                                    Primary Pharmacy
                                  </Typography>
                                )}
                              </Box>
                            </Stack>

                            {/* Contact Info */}
                            <Box sx={{ 
                              backgroundColor: isAccepted 
                                ? alpha(theme.palette.success.main, 0.05)
                                : alpha(theme.palette.background.paper, 0.8),
                              p: 1,
                              borderRadius: 1,
                              border: isAccepted 
                                ? `1px solid ${alpha(theme.palette.success.main, 0.2)}`
                                : `1px solid ${alpha(theme.palette.divider, 0.1)}`
                            }}>
                              <Stack direction="row" alignItems="center" justifyContent="space-between">
                                <Stack direction="row" alignItems="center" spacing={0.5}>
                                  <MdPhone size={12} color={theme.palette.text.secondary} />
                                  <Typography 
                                    variant="caption" 
                                    sx={{ 
                                      fontFamily: 'monospace',
                                      fontWeight: isAccepted ? 600 : 400
                                    }}
                                  >
                                    {pharmacy.pharmacyPhone}
                                  </Typography>
                                </Stack>
                                <IconButton
                                  size="small"
                                  onClick={() => handleCall(pharmacy.pharmacyPhone)}
                                  sx={{
                                    color: theme.palette.success.main,
                                    backgroundColor: alpha(theme.palette.success.main, 0.1),
                                    width: 20,
                                    height: 20
                                  }}
                                >
                                  <MdCall size={10} />
                                </IconButton>
                              </Stack>
                            </Box>

                            {/* Status Chip */}
                            <Stack direction="row" justifyContent="space-between" alignItems="center">
                              <Chip 
                                label={pharmacy.status}
                                icon={statusConfig.icon}
                                size="small"
                                sx={{ 
                                  backgroundColor: statusConfig.bgColor,
                                  color: statusConfig.color,
                                  border: `1px solid ${alpha(statusConfig.color, 0.3)}`,
                                  fontWeight: isAccepted ? 700 : 600,
                                  fontSize: '0.7rem',
                                  height: isAccepted ? 24 : 20
                                }}
                              />
                              {isAccepted && (
                                <Typography 
                                  variant="caption" 
                                  sx={{ 
                                    color: theme.palette.success.main,
                                    fontWeight: 600,
                                    backgroundColor: alpha(theme.palette.success.main, 0.1),
                                    px: 0.5,
                                    py: 0.2,
                                    borderRadius: 0.5,
                                    fontSize: '0.6rem'
                                  }}
                                >
                                  📦 Order Assigned
                                </Typography>
                              )}
                            </Stack>

                          </Stack>
                        </Paper>
                      );
                    }) || (
                    <Box textAlign="center" sx={{ py: 3 }}>
                      <Typography variant="body2" color="text.secondary">
                        No pharmacies assigned yet
                      </Typography>
                    </Box>
                  )}
                </Stack>
              </Box>
            </CardContent>
          </Card>
        </Grid>

        {/* Prescription Image */}
        {order?.precriptionUrl && (
          <Grid item xs={12}>
            <Card elevation={0} sx={{ 
              borderRadius: 2, 
              border: `1px solid ${alpha(theme.palette.divider, 0.08)}`
            }}>
              <CardContent sx={{ p: 2 }}>
                <Stack direction="row" alignItems="center" spacing={1.5} sx={{ mb: 2 }}>
                  <Avatar sx={{ 
                    backgroundColor: alpha(theme.palette.primary.main, 0.1),
                    color: theme.palette.primary.main,
                    width: 32,
                    height: 32
                  }}>
                    <MdImage size={18} />
                  </Avatar>
                  <Typography variant="body1" fontWeight={600} color="primary.main">
                    Prescription Image
                  </Typography>
                </Stack>
                <Box
                  component="img"
                  src={order.precriptionUrl}
                  alt="Prescription"
                  sx={{
                    width: "100%",
                    maxHeight: 400,
                    objectFit: "contain",
                    borderRadius: 2,
                    border: `1px solid ${alpha(theme.palette.divider, 0.2)}`
                  }}
                />
              </CardContent>
            </Card>
          </Grid>
        )}
      </Grid>

      <Snackbar
        open={awbSnack.open}
        autoHideDuration={3500}
        onClose={() => setAwbSnack({ ...awbSnack, open: false })}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert severity={awbSnack.severity} variant="filled">
          {awbSnack.msg}
        </Alert>
      </Snackbar>

      <CancelRefundModal
        open={cancelOpen}
        onClose={() => setCancelOpen(false)}
        order={order?.order}
        onDone={() => {
          fetchOrder();
        }}
      />
    </Container>
  );
};

export default OpenOrdersIndividual;
